import { themes } from 'kb-shared';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  height: 100%;

  border: solid 4px ${themes.colors.KBYellow};
  background-color: ${themes.colors.KBWhite};

  padding: 20px 25px 20px 25px;
`;

const Heading = styled(Link)`
  color: ${themes.colors.KBNight};
  ${themes.fonts.DomaineDisplay};

  font-size: 36px;
  text-align: center;
  margin-bottom: 20px;
  text-decoration: underline;
`;

const CareTeamWidget = () => {
  return (
    <Container>
      <Heading to="/care-team">Your Care Team</Heading>
    </Container>
  );
};

export default CareTeamWidget;
